import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from '../../../core/service/navigation.service';
import { UserAccountService } from '../user-account.service';
import { ModuleNames } from '../../model/account-definition';
import { SessionService } from '../../../core/service/session.service';

@Injectable()
export class ImdGuard {
  constructor(
    private _userAccount: UserAccountService,
    private _session: SessionService,
    private _navigation: NavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    if (!this._session.expired()) {
      return true;
    }
    this._session.redirectUrl = state.url;
    this._navigation.navigateLogin();
    return false;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }
}
